import React, { useState, useContext } from 'react';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { AllContext } from '../context/ContextAll';
import { isMobile } from 'react-device-detect';

export const LoginForm = () => {
  return(
    <>
    {isMobile ? <LoginFormMobile/> : <LoginFormPC/>}
    </>
  )
}
export const LoginFormPC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setAdmLogeado, setUserEmail } = useContext(AllContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    const auth = getAuth();

    try {
      await signInWithEmailAndPassword(auth, email, password);
      setAdmLogeado(true);
      setUserEmail(email);
      navigate("/dashboard");
      setError('');
    } catch (error) {
      console.error('Error de logeo:', error);
      setError('Error: ' + error.message);
    }
  };

  return (
    <div className="m_header_membresia w-100 h-100">
    <div className="d-flex ñssñ justify-content-center align-items-center w-100 h-100">
      {/* login */}
      <div className="m_w_40 m_h100vw">
      <form onSubmit={handleLogin} className="form-signin d-flex flex-column mt-5 pt-4 ms-5 ps-5">
        <h2 className="form-signin-heading text-white mb-3">Iniciar Sesión</h2>
        <div className="form-group d-flex ">
          <label className='text-white fs-4 m_w_40' htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-control"
            required
          />
        </div>
        <div className="form-group d-flex my-3">
          <label className='text-white fs-4 m_w_40' htmlFor="password">Contraseña:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="form-control"
            required
          />
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className="">
          <button type="submit" className="btn btn-primary m_w_30">Loguearse</button>
        </div>
      </form>
      </div>
      {/* membresia */}
      <div className="pt-5 m_w_60 d-flex justify-content-center align-items-center">
        <div className="pt-5 text-white m_w_60 ms-4">
          <div className=" me-5 pe-4">
            <h3>Bienvenido a Nuestra Comunidad</h3>
            <p>
              Únete a nosotros y accede a contenido exclusivo. 
              En nuestra plataforma podrás disfrutar de artículos, PDFs, y material de lectura diseñado especialmente para ti.
            </p>
          </div>
          <div className="ms-5 ps-5 my-4 py-4">
            <h2>¿Por qué unirte?</h2>
            <p>
              Disfruta de contenido exclusivo y de alta calidad, disponible solo para miembros pagos. 
              Desde artículos profundos hasta recursos descargables, ofrecemos todo lo que necesitas para aprender y mejorar.
            </p>
          </div>
          <div className=" me-5 pe-4">
            <h3>Nuestros Niveles de Membresía</h3>
            <ul className='mb-5 pb-5'>
              <li><strong>Membresía Gratuita:</strong> Acceso a contenido básico y actualizaciones regulares.</li>
              <li><strong>Membresía Premium:</strong> Acceso completo a todos los artículos, PDFs y recursos exclusivos para miembros.</li>
            </ul>
          </div>

        </div>
      </div>

      </div>
    </div>
  );
};

const LoginFormMobile =()=>{
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setAdmLogeado, setUserEmail } = useContext(AllContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    const auth = getAuth();

    try {
      await signInWithEmailAndPassword(auth, email, password);
      setAdmLogeado(true);
      setUserEmail(email);
      navigate("/dashboard");
      setError('');
    } catch (error) {
      console.error('Error de logeo:', error);
      setError('Error: ' + error.message);
    }
  };

  return (
    <div className="m_header_membresia w-100 h-100">
      <div className="d-flex flex-column ñssñ justify-content-center align-items-center w-100 h-100">
      
      {/* membresia */}
        <div className="pt-5 m_w_80 d-flex justify-content-center align-items-center">
          <div className="text-white">
            <div className="">
              <h3>Bienvenido a Nuestra Comunidad</h3>
              <p>
                Únete a nosotros y accede a contenido exclusivo. 
                En nuestra plataforma podrás disfrutar de artículos, PDFs, y material de lectura diseñado especialmente para ti.
              </p>
            </div>
            <div className="">
              <h2>¿Por qué unirte?</h2>
              <p>
                Disfruta de contenido exclusivo y de alta calidad, disponible solo para miembros pagos. 
                Desde artículos profundos hasta recursos descargables, ofrecemos todo lo que necesitas para aprender y mejorar.
              </p>
            </div>
            <div className=" ">
              <h3>Nuestros Niveles de Membresía</h3>
              <ul className=''>
                <li><strong>Membresía Gratuita:</strong> Acceso a contenido básico y actualizaciones regulares.</li>
                <li><strong>Membresía Premium:</strong> Acceso completo a todos los artículos, PDFs y recursos exclusivos para miembros.</li>
              </ul>
            </div>

          </div>
        </div>

      {/* login */}
        <div className="w-100 m_h100vw">
          <form onSubmit={handleLogin} className="form-signin d-flex flex-column mt-5 pt-5 mx-2">
            <h2 className="form-signin-heading text-white mb-3">Iniciar Sesión</h2>
            <div className="form-group d-flex ">
              <label className='text-white fs-4 m_w_40' htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-control"
                required
              />
            </div>
            <div className="form-group d-flex my-3">
              <label className='text-white fs-4 m_w_40' htmlFor="password">Contraseña:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control"
                required
              />
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="">
              <button type="submit" className="btn btn-primary m_w_30">Loguearse</button>
            </div>
          </form>
        </div>

      </div>
    </div>
  );
};
